<template>
    <div class="filter__filters d-flex flex-column flex-md-row justify-content-between align-items-center">
        <p class="filter__filters-label">{{GuidesLandingPageFilterLabel}}</p>

        <div class="filter__filters-controls flex-column flex-sm-row d-flex align-items-center flex-wrap">
            <fragment v-for="(filter, index) in filters" v-bind:key="index">
                <div class="form-group">
                    <select v-if="filter.type == 'select'"
                            v-select2
                            :value="filter.selected"
                            class="form-control"
                            @change="handleFilterChange($event, filter.key)"
                            :id="`filter-${index}`"
                            ref="select2Elem">
                        <option :value="null"
                               hidden
                               class="option-label"
                               disabled="disabled">
                            {{ filter.label }}
                        </option>
                        <option v-for="filterOption in filter.options"
                                :value="filterOption.value">
                            {{ filterOption.text }}
                        </option>
                    </select>
                    <div v-if="filter.type == 'checkbox'" class="filter__filters-checkbox">
                        <label>
                            {{ filter.label }}
                            <input type="checkbox"
                                   :checked="filter.selected"
                                   :value="filter.value" 
                                   @change="handleCheckFilterChange($event, filter.key)"
                                   class="form-control">
                            <span></span>
                        </label>
                    </div>
                </div>
            </fragment>

            <transition name="fade">
                <div v-if="clearButtonVisible" class="form-group">
                    <button @click="handleClearFilter" class="btn btn-outline-secondary btn-clear" type="submit">{{FiltersClearText}}</button>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    import { Fragment } from 'vue-fragment';
    import { mapActions, mapMutations, mapGetters } from 'vuex';

    export default {
        data() {
            return {
                isDirty: false,
            }
        },
        props: {
            filters: {
                type: Array,
                required: true,
            }
        },

        computed: {
            clearButtonVisible() {
                return this.selectedFilters.length > 0;
            },
             
            ...mapGetters('rooms', [
                'selectedFilters',
            ]),

            GuidesLandingPageFilterLabel() {
                return window.GuidesLandingPageFilterLabel;
            },

            FiltersClearText() {
                return window.FiltersClearText;
            }

        },

        components: {
            Fragment,
        },

        methods: {
            handleFilterChange(e, key) {
                if (e.target.value == null || e.target.value == '') return;

                this.isDirty = true;
                this.setLoading(true);

                setTimeout(() => {
                    this.setFilter([key, e.target.value]);
                    
                    // Delay fade in so we can ensure filter DOM has applied.
                    setTimeout(() => {
                        this.setLoading(false);
                    }, 500);
                }, 500);
            },

            handleCheckFilterChange(e, key) {
                if (e.target.value == null || e.target.value == '') return;
                
                this.setLoading(true);
                setTimeout(() => {
                    if (e.target.checked) {
                        this.setFilter([key, e.target.value]);
                    } else {
                        this.setFilter([key, null]);
                    }

                    // Delay fade in so we can ensure filter DOM has applied.
                    setTimeout(() => {
                        this.setLoading(false);
                    }, 500);
                }, 500);
            },

            handleClearFilter() {
                this.setLoading(true);
                const self = this;
                
                setTimeout(() => {
                    this.clearFilters();
                    self.$refs.select2Elem.value = '';
                    self.$refs.select2Elem.at(0).value = '';
                    self.$refs.select2Elem.at(0).dispatchEvent(new Event('change'));
                    this.setLoading(false);
                }, 1000);
            },

            ...mapActions('rooms', [
                'setFilter',
            ]),

            ...mapMutations('rooms', [
                'clearFilters',
                'setLoading'
            ]),
        }
    }
</script>